import * as React from "react";
import { css } from "@emotion/react";
import { FullScreenModalDialog } from "main/javascripts/components/molecules/Modal/FullScreenModalDialog";
import { ImageListWithThumbnail } from "main/javascripts/components/spot/ImageListWithThumbnail";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import { Cruise } from "main/javascripts/types/cruise";

export interface IProps {
  vessel: Cruise.Vessel;
  isDisplayed: boolean;
  onClose: any;
}

export const CruiseVesselImageModal: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { vessel, isDisplayed, onClose } = props;

  const images = vessel.vesselImages || [];

  if (images.length === 0) {
    return null;
  }

  const imageData = images.map((image) => {
    return {
      url: image.imageUrl,
      isDefault: false,
    };
  });

  const closeHandler: () => void = () => {
    onClose();
  };

  const imageListStyles = {
    exBlockStyle: slideBlockStyle,
    exGallerySliderStyle: gallerySliderBlockStyle,
  };

  return (
    // TODO: 旧コンポーネント使用中
    <FullScreenModalDialog displayed={isDisplayed} closeHandler={closeHandler}>
      {imageData && (
        <ImageListWithThumbnail images={imageData} styles={imageListStyles} />
      )}
    </FullScreenModalDialog>
  );
};

const slideBlockStyle = css`
  max-width: 90vw;
  max-height: 90vh;
`;

const gallerySliderBlockStyle = css`
  .swiper-wrapper {
    height: calc(70vh - 10rem);

    ${moreThanBreakpoint("desktop")} {
      height: calc(90vh - 10rem);
    }
  }
`;
